module.exports = __webpack_public_path__ + "static/media/the-big-idea.7f8a6cb0.png";